export default {
    // drawer: false, 
    id: "",
    name: "", 
    // posAlphabet: "A", 
    // preventRestart: false, 
    // printerId: "", 
    shiftId: "", 
    uniqueId: "", // เครื่องที่ผูกอยู่กับแคชเชียร์นี้
    printerType:'bluetooth',
    printerSize:'58',
    printerBluetooth:{
        android:{
            address:'',
            name:''
        },
        ios:{
            address:'',
            name:''
        },
    },
    printerEthernet:'',
    printerUsb:{
      vendor_id:'',
      product_id:'',
      device_name:''
    },
    posNumber:'',
    deviceName:''
};